// assets/begin-checkout-fallback.js
(function () {
  // --- Debug sólo en modo editor del theme ---
  const DEBUG = !!(window.Shopify && Shopify.designMode);
  const log = (...a) => DEBUG && console.log('[begin_checkout fallback]', ...a);

  // Anti-duplicados: evita dos pushes en ráfaga (click + submit)
  const TTL_MS = 1200;
  let lastTs = 0;
  const dedupe = () => {
    const t = Date.now();
    if (t - lastTs < TTL_MS) return true;
    lastTs = t;
    return false;
  };

  function getCurrency() {
    try {
      if (window.Shopify?.currency?.active) return Shopify.currency.active;
      if (window.ShopifyAnalytics?.meta?.currency) return ShopifyAnalytics.meta.currency;
    } catch (e) {}
    return undefined;
  }

  function mapItem(i) {
    return {
      item_id: i.sku || i.variant_id || i.id,
      item_name: i.product_title,
      item_brand: i.vendor || null,
      item_category: i.product_type || null,
      item_variant: i.variant_title || null,
      price: (typeof i.price === 'number' ? i.price : Number(i.price)) / 100 || 0,
      currency: getCurrency() || null,
      quantity: i.quantity
    };
  }

  async function pushBeginCheckout() {
    if (dedupe()) return;
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      const items = (cart.items || []).map(mapItem);
      const value = items.reduce((s, it) => s + (it.price || 0) * (it.quantity || 0), 0);
      const currency = items[0]?.currency || getCurrency();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'begin_checkout', ecommerce: { currency, value, items } });
      log('pushed', { currency, value, itemsCount: items.length });
    } catch (e) {
      log('error', e);
    }
  }

  // Detecta botones/enlaces de checkout más comunes (tema/cart drawer/apps)
  function isCheckoutEl(el) {
    if (!el) return false;
    // Botones estándar
    if (el.matches('button[name="checkout"], [name="checkout"], #checkout')) return true;
    // Enlaces a checkout
    if (el.matches('a[href*="/checkout"], a[href*="/checkouts/"]')) return true;
    // ATRIBUTOS habituales en temas/apps
    if (el.matches('[data-checkout-button], [data-action="checkout"], [data-analytics*="checkout"]')) return true;
    // Botones de pago acelerado dentro del carrito/drawer
    if (el.closest('.shopify-payment-button')) return true;
    // Clases comunes de temas
    if (el.matches('.cart__checkout, .cart__submit, .cart__button--checkout, .drawer__checkout')) return true;
    return false;
  }

  // Eventos tempranos para capturar antes de navegar
  const CLICK_EVENTS = ['click', 'pointerdown'];
  CLICK_EVENTS.forEach(evt => {
    document.addEventListener(evt, (e) => {
      const el = e.target.closest('a,button,[data-checkout-button],[data-action="checkout"],.shopify-payment-button');
      if (!isCheckoutEl(el)) return;
      log('detected', evt, el);
      // Empuja sin bloquear la navegación
      pushBeginCheckout();
    }, true);
  });

  // Submit de formularios del carrito (incluye drawer con form)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action^="/cart"]');
    if (!form) return;
    const isCheckoutSubmit =
      (e.submitter && (e.submitter.name === 'checkout' || isCheckoutEl(e.submitter))) ||
      form.querySelector('input[name="checkout"]');
    if (!isCheckoutSubmit) return;
    log('detected submit', form);
    pushBeginCheckout();
  }, true);

  // Teclas (Enter/Espacio) sobre botones/enlaces de checkout
  document.addEventListener('keydown', (e) => {
    if (!['Enter', ' '].includes(e.key)) return;
    const el = e.target.closest('a,button');
    if (!isCheckoutEl(el)) return;
    log('detected key', e.key, el);
    pushBeginCheckout();
  }, true);

  log('ready');
})();
